<template>
  <div>
    <div class="small">{{$t(`LoanApplicationTimeline.signingLocation.${signingLocation}`)}}</div>
    <router-link :to="{name: 'branches',  query: { filter: 'signing' }}"
                  v-if="signingLocation === 'office'"
                  class="btn btn-sm btn-primary mt-3 mb-2 px-3">
      {{ $t('LoanApplicationTimeline.findSigningLocations') }}
    </router-link>
  </div>
</template>
<script>
const AVAILABLE_LOCATIONS = ['office', 'abi', 'posta', 'dealer']

export default {
  name: 'SigningStageComponent',
  props: ['application'],
  computed: {
    signingLocation() {
      return AVAILABLE_LOCATIONS.includes(this.application.signingLocation) ? this.application.signingLocation : 'office'
    }
  }
}
</script>
